import { Expression, ShapeBase } from '~/prix/types/expression'
import { truthy } from '~/prix'
import { citizenExpression } from '~/packages/general/citizen/list/citizenList.definition'
import { z } from 'zod'
import { getBaseType, getMeta } from '~/prix/types/zodType'

export type ExpressionOption = Expression & {
  value: string
  label: string
}

export function getCitizenPublicTargets(): ExpressionOption[] {
  const shape = citizenExpression?.getMeta()?.shape as ShapeBase
  if (!shape) {
    return []
  }

  return Object.keys(shape)
    .map(key => {
      const fieldSchema: z.ZodType = shape[key]
      const fieldBaseType = getBaseType(fieldSchema)

      if (fieldBaseType instanceof z.ZodBoolean) {
        const expressionOption: ExpressionOption = {
          value: key,
          label: fieldSchema.description!,
          type: 'expression',
          kind: 'binary',
          left: {
            type: 'expression',
            kind: 'property',
            property: key,
          },
          operator: '=',
          right: {
            type: 'expression',
            kind: 'literal',
            literalType: 'boolean',
            value: true,
          },
        }
        return expressionOption
      }
      if (fieldBaseType instanceof z.ZodEnum && getMeta(fieldBaseType)) {
        const keysAndLabels: Record<string, string> = (getMeta(fieldSchema)?.keysAndLabels ||
          {}) as Record<string, string>

        return Object.keys(keysAndLabels).map(enumKey => {
          const expressionOption: ExpressionOption = {
            value: `${key}.${enumKey}`,
            label: `${keysAndLabels[enumKey]} (${fieldSchema.description})`,
            type: 'expression',
            kind: 'binary',
            left: {
              type: 'expression',
              kind: 'property',
              property: key,
            },
            operator: '=',
            right: {
              type: 'expression',
              kind: 'literal',
              literalType: 'string',
              value: enumKey,
            },
          }
          return expressionOption
        })
      }
      return null
    })
    .filter(truthy)
    .flat()
}
